'use strict';

import Cart from './cart/cart';

document.addEventListener('DOMContentLoaded', () => {
    Cart.run();
});
